// SocialCheck Pocket — customer-facing translations (DE/FR/IT/EN)
export const pocketTranslations = {
  de: {
    heading: "Machen Sie ein Foto.",
    heading2: "Wir machen daraus Ihren nächsten Beitrag.",
    sub: "Kein Text, keine Hashtags, kein Aufwand. Foto oder Video senden — KEWAG bereitet alles passend für Sie vor.",
    steps: { s1: "Aufnehmen oder wählen", s2: "Kurz ergänzen", s3: "An KEWAG senden" },
    dropEmpty: "Noch nichts hochgeladen",
    dropHint: "JPG, PNG, MP4 bis 200 MB",
    takeTitle: "Foto / Video aufnehmen",
    takeSub: "Kamera öffnen",
    chooseTitle: "Aus Galerie wählen",
    chooseSub: "Bereits vorhandene Datei wählen",
    changePhoto: "Andere Datei",
    info: {
      i1: "Wird dem richtigen Projekt zugeordnet",
      i2: "Im Bereich Speicher & Medien vorbereitet",
      i3: "Titel und Medientyp werden passend vorbereitet",
      i4: "KEWAG prüft alles vor der Veröffentlichung",
    },
    classifyTitle: "Kurz einordnen (optional)",
    classifyHint: "Hilft uns noch schneller weiter — kann auch übersprungen werden.",
    cats: {
      angebot: "Angebot", stellenangebot: "Stellenangebot", event: "Event",
      neues_produkt: "Neues Produkt", vorher_nachher: "Vorher / Nachher", kewag_entscheidet: "KEWAG entscheidet",
    },
    notePlaceholder: "Kurze Notiz hinzufügen (optional)",
    rights: "Ich bestätige, dass ich die Rechte am Bild/Video habe.",
    send: "An KEWAG senden",
    sending: "Wird gesendet…",
    uploading: "Wird hochgeladen…",
    secure: "Sicher übermittelt",
    successTitle: "Danke!",
    success: "Ihre Datei ist bei KEWAG angekommen. Wir bereiten daraus Ihren Beitrag vor und prüfen alles vor der Veröffentlichung.",
    another: "Weitere Datei senden",
    backToApp: "Zurück zur App",
    sentStatus: "Bei KEWAG eingegangen",
    sentAtLabel: "Sicher übermittelt um",
    toCockpit: "Zum Cockpit",
    rightsError: "Bitte bestätigen Sie die Bildrechte.",
    noPhotoError: "Bitte wählen Sie zuerst ein Foto oder Video.",
    tooLarge: "Datei zu gross — maximal 200 MB.",
    badType: "Nur JPG, PNG, WEBP oder MP4.",
    error: "Senden fehlgeschlagen. Bitte erneut versuchen.",
    noTenant: "Ihrem Konto ist noch kein Mandant zugewiesen. Bitte kontaktieren Sie KEWAG.",
  },
  fr: {
    heading: "Prenez une photo.",
    heading2: "Nous en faisons votre prochaine publication.",
    sub: "Pas de texte, pas de hashtags, aucun effort. Envoyez une photo ou une vidéo — KEWAG prépare tout pour vous.",
    steps: { s1: "Capturer ou choisir", s2: "Compléter brièvement", s3: "Envoyer à KEWAG" },
    dropEmpty: "Rien n’a encore été téléversé",
    dropHint: "JPG, PNG, MP4 jusqu’à 200 Mo",
    takeTitle: "Photo / vidéo",
    takeSub: "Ouvrir la caméra",
    chooseTitle: "Choisir dans la galerie",
    chooseSub: "Sélectionner un fichier existant",
    changePhoto: "Autre fichier",
    info: {
      i1: "Attribué au bon projet",
      i2: "Préparé dans Stockage & Médias",
      i3: "Titre et type de média préparés",
      i4: "KEWAG vérifie tout avant publication",
    },
    classifyTitle: "Classer brièvement (facultatif)",
    classifyHint: "Nous aide encore plus vite — peut aussi être ignoré.",
    cats: {
      angebot: "Offre", stellenangebot: "Offre d’emploi", event: "Événement",
      neues_produkt: "Nouveau produit", vorher_nachher: "Avant / Après", kewag_entscheidet: "KEWAG décide",
    },
    notePlaceholder: "Ajouter une courte note (facultatif)",
    rights: "Je confirme détenir les droits sur l’image/la vidéo.",
    send: "Envoyer à KEWAG",
    sending: "Envoi en cours…",
    uploading: "Téléversement…",
    secure: "Transmis en sécurité",
    successTitle: "Merci !",
    success: "Votre fichier est arrivé chez KEWAG. Nous en préparons une publication et vérifions tout avant publication.",
    another: "Envoyer un autre fichier",
    backToApp: "Retour à l’application",
    sentStatus: "Reçu chez KEWAG",
    sentAtLabel: "Transmis en toute sécurité à",
    toCockpit: "Vers le cockpit",
    rightsError: "Veuillez confirmer les droits d’image.",
    noPhotoError: "Veuillez d’abord choisir une photo ou une vidéo.",
    tooLarge: "Fichier trop volumineux — 200 Mo maximum.",
    badType: "Uniquement JPG, PNG, WEBP ou MP4.",
    error: "Échec de l’envoi. Veuillez réessayer.",
    noTenant: "Aucun mandant n’est encore attribué à votre compte. Veuillez contacter KEWAG.",
  },
  it: {
    heading: "Scatta una foto.",
    heading2: "Noi ne facciamo il tuo prossimo post.",
    sub: "Nessun testo, nessun hashtag, nessuno sforzo. Invia una foto o un video — KEWAG prepara tutto per te.",
    steps: { s1: "Scatta o scegli", s2: "Aggiungi qualcosa", s3: "Invia a KEWAG" },
    dropEmpty: "Ancora nulla caricato",
    dropHint: "JPG, PNG, MP4 fino a 200 MB",
    takeTitle: "Foto / video",
    takeSub: "Apri la fotocamera",
    chooseTitle: "Scegli dalla galleria",
    chooseSub: "Seleziona un file esistente",
    changePhoto: "Altro file",
    info: {
      i1: "Assegnato al progetto giusto",
      i2: "Preparato in Archivio & Media",
      i3: "Titolo e tipo di media preparati",
      i4: "KEWAG verifica tutto prima della pubblicazione",
    },
    classifyTitle: "Classifica brevemente (facoltativo)",
    classifyHint: "Ci aiuta ancora più in fretta — può anche essere saltato.",
    cats: {
      angebot: "Offerta", stellenangebot: "Offerta di lavoro", event: "Evento",
      neues_produkt: "Nuovo prodotto", vorher_nachher: "Prima / Dopo", kewag_entscheidet: "Decide KEWAG",
    },
    notePlaceholder: "Aggiungi una breve nota (facoltativo)",
    rights: "Confermo di avere i diritti sull’immagine/video.",
    send: "Invia a KEWAG",
    sending: "Invio in corso…",
    uploading: "Caricamento…",
    secure: "Trasmesso in sicurezza",
    successTitle: "Grazie!",
    success: "Il tuo file è arrivato a KEWAG. Ne prepariamo un post e verifichiamo tutto prima della pubblicazione.",
    another: "Invia un altro file",
    backToApp: "Torna all’app",
    sentStatus: "Ricevuto da KEWAG",
    sentAtLabel: "Trasmesso in sicurezza alle",
    toCockpit: "Al cockpit",
    rightsError: "Conferma i diritti dell’immagine.",
    noPhotoError: "Scegli prima una foto o un video.",
    tooLarge: "File troppo grande — massimo 200 MB.",
    badType: "Solo JPG, PNG, WEBP o MP4.",
    error: "Invio non riuscito. Riprova.",
    noTenant: "Al tuo account non è ancora assegnato un cliente. Contatta KEWAG.",
  },
  en: {
    heading: "Take a photo.",
    heading2: "We turn it into your next post.",
    sub: "No text, no hashtags, no effort. Send a photo or video — KEWAG prepares everything for you.",
    steps: { s1: "Capture or choose", s2: "Add a little", s3: "Send to KEWAG" },
    dropEmpty: "Nothing uploaded yet",
    dropHint: "JPG, PNG, MP4 up to 200 MB",
    takeTitle: "Photo / video",
    takeSub: "Open camera",
    chooseTitle: "Choose from gallery",
    chooseSub: "Select an existing file",
    changePhoto: "Change file",
    info: {
      i1: "Assigned to the right project",
      i2: "Prepared in Storage & Media",
      i3: "Title and media type prepared",
      i4: "KEWAG reviews everything before publishing",
    },
    classifyTitle: "Quick classify (optional)",
    classifyHint: "Helps us even faster — can also be skipped.",
    cats: {
      angebot: "Offer", stellenangebot: "Job opening", event: "Event",
      neues_produkt: "New product", vorher_nachher: "Before / After", kewag_entscheidet: "KEWAG decides",
    },
    notePlaceholder: "Add a short note (optional)",
    rights: "I confirm I hold the rights to the image/video.",
    send: "Send to KEWAG",
    sending: "Sending…",
    uploading: "Uploading…",
    secure: "Securely transmitted",
    successTitle: "Thank you!",
    success: "Your file has reached KEWAG. We are preparing your post and review everything before publishing.",
    another: "Send another file",
    backToApp: "Back to app",
    sentStatus: "Received by KEWAG",
    sentAtLabel: "Securely delivered at",
    toCockpit: "To cockpit",
    rightsError: "Please confirm the image rights.",
    noPhotoError: "Please choose a photo or video first.",
    tooLarge: "File too large — 200 MB maximum.",
    badType: "Only JPG, PNG, WEBP or MP4.",
    error: "Sending failed. Please try again.",
    noTenant: "No client is assigned to your account yet. Please contact KEWAG.",
  },
};
